const isNotObject = obj => obj !== Object(obj) || Array.isArray(obj)

export default (object = {}, transformers) =>
  Object.entries(object).reduce((acc, [key, value]) => {
    const transformer = transformers[key]
    const transformedData = transformer ? transformer(value, acc) : { [key]: value }

    // this allows the transformer to return a static val for the same key
    // if an object is returned it will be merged with the current transformed object
    if (isNotObject(transformedData)) {
      acc[key] = transformedData
      return acc
    }

    return {
      ...acc,
      ...transformedData
    }
  }, {})
